import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthGaurdService } from './auth-gaurd.service';
import { CalRunIdModel } from '../models/config/calrunid.model';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';

@Injectable({
    providedIn: 'root'
})
export class CalRunIdService {

    private host = environment.apiUrl + "config/calrunids";
    public loggedinUser: string = '';

    selectedCalcModel = new CalRunIdModel('', 0, '', '', '', null, '', null, '', false, '', null, null, '', '', '', '', 0, 0);

    constructor(private http: HttpClient,
        private logger: LoggerService, private authGaurdService: AuthGaurdService) {
        this.loggedinUser = this.authGaurdService.loginUser();
        console.log("this.loggedinUser: " + this.loggedinUser);
    }

    public suspendRun(id: number): Observable<CustomHttpRespone> {
        return this.http.delete<CustomHttpRespone>(`${this.host}/suspendrun/` + id );
      }

    public addCalRunId(formData: FormData): Observable<CalRunIdModel> {
        return this.http.post<CalRunIdModel>(`${this.host}/addcalrunid`, formData);
    }

    public updateCalRunId(formData: FormData): Observable<CalRunIdModel> {
        return this.http.post<CalRunIdModel>(`${this.host}/updatecalrunid`, formData);
    }

    public getUserIds(): Observable<CalRunIdModel[]> {
        return this.http.get<CalRunIdModel[]>(`${this.host}/getuseridsdropdown`);
    }

    public getRunCtrlIds(): Observable<CalRunIdModel[]> {
        return this.http.get<CalRunIdModel[]>(`${this.host}/getruncontrolsdropdown`);
    }

    public downloadLogFile(uid: string, calRunId: number, comm_plan_id: number) {
        // HOA-8442: route through the Java backend proxy (trusted *.run.app origin) instead of
        // the engine's private IP. Log download needs no engine credential, so nothing but the
        // path is sent.
        const url = `${environment.apiUrl}engine/log/download/${uid}/${calRunId}/${comm_plan_id}`;
        return this.http.get<Blob>(url, { observe: 'response', responseType: 'blob' as 'json' })
            .pipe(
                map((data: any) => {
                    return data;
                }), catchError(error => {
                    this.logger.info(' error ==> ', error);

                    return throwError(error);
                })
            )
    }



    public getProcessStatus(userId: string, runCtrlId: number, startTime: string, endTime: string): Observable<CalRunIdModel[]> {
        return this.http.get<CalRunIdModel[]>(`${this.host}/getprocessstatus` + '/' + userId + '/' + runCtrlId + '/' + startTime + '/' + endTime);
    }


    public getCalRunIdList() {
        let url = this.host + '/getcalrunidlist';
        return this.http.get<CalRunIdModel[]>(url)
            .pipe(
                map((data: CalRunIdModel[]) => {
                    return data;
                }), catchError(error => {
                    this.logger.info(' error ==> ', error);
                    return throwError('Something went wrong!');
                })
            )
    }



    public createCalRunIdForm(calendarModel: CalRunIdModel): FormData {
        const formData = new FormData();

        console.log(calendarModel.calRunId);
        console.log(calendarModel.description);
        console.log(this.loggedinUser);

        formData.append('id', calendarModel.id);
        formData.append('cal_run_id', calendarModel.calRunId);
        formData.append('description', calendarModel.description);
        formData.append('currentUser', this.loggedinUser);

        return formData;
    }

    public handleError(error: { error: { message: string; }; status: any; message: any; }) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        window.alert(errorMessage);
        return throwError(errorMessage);
    }
}


